const Avatar = (props) => {
  const image = `https://api.dicebear.com/9.x/adventurer/svg?seed=tambo${props.id}`;
  return <img alt={`avatar_${props.id}`} style={{width: "3vw", height: "3vw", zIndex: props.position ? props.position : ""}} src={image} />;
};

export default Avatar;